<template>
  <!-- 动态选择弹窗类型 -->
  <component :is="isMobile ? 'el-drawer' : 'el-dialog'" :visible.sync="dialogVisible"
    :direction="isMobile ? 'btt' : undefined" :width="isMobile ? '90%' : '30%'" :before-close="handleClose"
    custom-class="popStyle" :lock-scroll="true" :top="isMobile ? undefined : '25vh'" :show-close="false">
    <!-- 弹窗标题 -->
    <div slot="title">
      <div class="popStyle_title">{{ $t(popTitle) }} </div>
      <div>
        <img class="popStyle_close" @click="handleClose" src="@/assets/images/close.png" alt="" v-if="closeShow" />
      </div>
    </div>
    <div class="popStyle_scroll">
      <div v-if="hasBodyTitleSlot">
        <slot name="bodyTitle"></slot>
      </div>
      <div v-else>
        <div style="display: flex; flex-direction: column; padding: 1rem">
          <el-radio style="margin-bottom: 1rem" v-for="(item, index) in LangLists" :key="index" v-model="radio"
            :label="item.id">{{ item.title }}</el-radio>
        </div>
      </div>
    </div>

    <!-- 弹窗底部按钮 -->
    <div :class="isMobile ? 'drawer-footer' : 'dialog-footer'">
      <div class="dialog-footer_sty">
        <div></div>
        <el-button type="primary" @click="handleSubmit">
          {{ $t("确定") }}
        </el-button>
      </div>
    </div>
  </component>
</template>
<script>
import { isMobile } from "@/utils/utils";
export default {
  name: "PopLang",
  props: {
    LangLists: {
      type: [Array, Object],
      default: () => [],
    },
    // 标题
    popTitle: {
      type: String,
      default: "选择语言",
    },
    dialogVisible: { type: Boolean, default: false }, // 控制弹窗显示
    closeShow: { type: Boolean, default: true }, // 控制关闭按钮显示
  },
  data() {
    return {

      radio: 1,
    };
  },
  computed: {
    isMobile() {
      return this.$isMobile;
    },
    hasBodyTitleSlot() {
      return !!this.$slots.bodyTitle; // 检测 #bodyTitle 插槽
    },
  },
  watch: {
    // dialogVisible(newVal) {
    //   if (newVal) {
    //     // // 弹窗打开时：禁止滚动
    //     document.body.style.overflow = "hidden";
    //     document.body.style.position = "fixed";
    //     document.body.style.width = "100%";
    //   } else {
    //     // 弹窗关闭时：恢复滚动
    //     document.body.style.overflow = "";
    //     document.body.style.position = "";
    //     document.body.style.width = "";
    //     this.num = 1;
    //     this.textValue = null;
    //   }
    // },
  },
  mounted() {
    this.getInit();

    // // 检测是否是移动端
    // this.checkIsMobile();
    // window.addEventListener("resize", this.checkIsMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkIsMobile);
  },
  methods: {
    getInit() {
      let p = this.$store.state.isLand || "zh";
      if (this.LangLists.length > 0) {
        let m = this.LangLists.filter((ite) => ite.value == p);
        this.radio = m ? m[0].id : 1;
      }
    },
    // 判断设备类型
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    // 关闭弹窗
    handleClose(done) {
      this.$emit("handleClose");
    },
    // 提交表单
    handleSubmit() {
      if (this.hasBodyTitleSlot) {
        this.$emit("submit");
      } else {
        this.$emit("submit", this.radio);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.popStyle_inp {
  padding: 0.5rem;
  margin-bottom: 1rem;

  ::v-deep .el-input__inner {
    background: #ffffff;
    border-radius: 0.2rem;
    border: 1px solid #545c8b !important;

    .el-input__inner::placeholder {
      color: #7e8190 !important;
      opacity: 1;
    }
  }
}

.popStyle_scroll {
  height: calc(100% - 70px);
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.popStyle_allnum {
  font-size: 0.7rem;
  color: #7e8190;
  margin-top: -1rem;

  span {
    color: #ff6200;
  }
}
</style>